import React from 'react';
import { EmptyState } from '../../commons';
import { InvalidSearchImg } from '../../../images/images';
import './Comments.scss';

export const Comments = ({ comments }) => {
  return (
    <div className='commentsPop modalContent'>
      {!comments ? (
        <EmptyState
          img={InvalidSearchImg}
          heading='No comments yet'
          subHeading='There are no previous comment for this order. You can add one below.'
          isPop={true}
        />
      ) : (
        <CommentsComp comments={comments} />
      )}
    </div>
  );
};

const CommentsComp = ({ comments }) => {
  return (
    <React.Fragment>
      {comments &&
        comments.map((comment, index) => (
          <div className='commentBlog' key={index}>
            <div className='commentText'>
              <p className='dark'>{comment.comment}</p>
            </div>
            <div className='commentFooter'>
              <div className='agentName'>
                <p className='lighter small' data-dd-privacy='mask'>
                  {comment.added_by}
                </p>
              </div>
              <div className='commentDate'>
                <p className='lighter small'>{comment.added_on}</p>
              </div>
            </div>
          </div>
        ))}
    </React.Fragment>
  );
};
